import { useStudentStore } from "../hooks/use-student-store";
import IntroductionCard from "../components/student/introduction-card";
import MaterialsSection from "../components/student/materials-section";
import ChatInterface from "../components/student/chat-interface";
import QuizSection from "../components/student/quiz-section";
import CompletionResults from "../components/student/completion-results";
import TimeStatusTable from "../components/student/time-status-table";
import { Loader2 } from "lucide-react";
import { StudentSubmissionStatus } from "@live-writing/models";

const StudentActivity = () => {
  const { preLesson, submission, loading, error } = useStudentStore();

  if (loading) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-purple-600" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center">
        <div className="text-center">
          <p className="text-red-600 text-lg">{error}</p>
          <p className="text-gray-500 mt-2">Please check the link and try again.</p>
        </div>
      </div>
    );
  }

  if (!preLesson || !submission) {
    return (
      <div className="min-h-[80vh] flex items-center justify-center">
        <div className="text-center">
          <p className="text-gray-600 text-lg">Submission not found</p>
        </div>
      </div>
    );
  }

  const isCompleted = submission.status === StudentSubmissionStatus.COMPLETED;

  return (
    <div className="py-6 px-4 max-w-2xl mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 space-y-6">
        <IntroductionCard />
        <MaterialsSection />

        {!isCompleted && (
          <>
            <ChatInterface />
            <QuizSection />
          </>
        )}
        <TimeStatusTable />
        {isCompleted && <CompletionResults />}
      </div>
    </div>
  );
};

export default StudentActivity;
